// extracted by mini-css-extract-plugin
export default {"layout":"overview_layout__zD4Fv","firstRow":"overview_firstRow__oz5cH","secondRow":"overview_secondRow__fNIZg"};